import {wymsFetch, getParams} from '@/utils/fetch';

// 查询菜单树
export function querySensitiveList(args) {
    const params = getParams();
    params.append('sensitiveWord', args.sensitiveWord);

    return wymsFetch({
        url: 'sensitive/querySensitiveList',
        method: 'GET',
        params
    });
}

// 新增敏感词
export function addSensitiveWordBatch(args) {
    const params = getParams();
    params.append('sensitiveWords', args.sensitiveWords);

    return wymsFetch({
        url: 'sensitive/addSensitiveWordBatch',
        method: 'GET',
        params
    });
}


// 删除敏感词
export function deleteBatchSensitiveWord(args) {
    const params = getParams();
    params.append('sensitiveWordIds', args.sensitiveWordIds);

    return wymsFetch({
        url: 'sensitive/deleteBatchSensitiveWord',
        method: 'GET',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/wordBlacklist.js